export default "__VITE_ASSET__CDKoLAUd__"